<template>
  <div>
    <v-card>
      <v-card-title>Asignar Seguro</v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="12" sm="6" md="6">
            <v-combobox
              v-model="agente"
              :items="agentesLst"
              item-text="nombre"
              item-value="id"
              label="Agente Asegurador"
              clearable
              append-icon="mdi-lock"
              return-object
            ></v-combobox>
          </v-col>          
        </v-row>
        <v-row>
            <v-col cols="12" md="6" sm="6">
            <v-text-field
              v-model="camposBD.seg_no_aplicacion"
              label="No de Aplicación"
              append-icon="mdi-folder-pound"
            ></v-text-field>
          </v-col>          
          <v-col cols="12" md="6" sm="6">
              <v-text-field
              v-model="camposBD.seg_valor_contenido"
              type="number"
              label="Valor del Contenido"
              append-icon="mdi-cash"
              @change="calcularTotal()"
              ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" sm="4" md="4">
                <v-text-field
                v-model="camposBD.seg_flete_int"
                type="number"
                label="Valor Flete Internacional"
                append-icon="mdi-cash"
                @change="calcularTotal()"
                ></v-text-field>
            </v-col>
            <v-col cols="12" sm="4" md="4">
                <v-text-field
                v-model="camposBD.seg_flete_nac"
                type="number"
                label="Valor Flete Nacional"
                append-icon="mdi-cash"
                @change="calcularTotal()"
                ></v-text-field>
            </v-col>
            <v-col cols="12" sm="4" md="4">
                <v-text-field
                readonly
                v-model="camposBD.seg_valor_total"
                type="number"
                label="Valor Total"
                append-icon="mdi-cash"
                ></v-text-field>
            </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer
        ><v-btn color="primary" outlined @click="asignar()">
          Guardar <v-icon>mdi-content-save</v-icon></v-btn
        >
      </v-card-actions>
    </v-card>
    <v-overlay :value="overlay">
      <waiting />
    </v-overlay>
  </div>
</template>

<script>
import Waiting from "./Waiting.vue";
import apicon from "../plugins/apicon";
export default {
  props: {
    id: {
      type: Number,
      default: null,
    },
  },
  components: {
    Waiting,
  },
  created: function () {},
  data() {
    return {      
      camposBD: {
        seg_id_agente: null,
        seg_no_aplicacion: null,
        seg_valor_contenido: null,
        seg_flete_int: null,
        seg_flete_nac: null,
        seg_valor_total: null
      },
      agentesLst:[],
      agente: null,      
      overlay: false,
    };
  },
  watch:{
      agente: function(item){
          if(item){
              this.camposBD.seg_id_agente = item.id;
          }
      }
  },
  methods: {
    fillAgentesLst: async function () {
      await apicon
        .getDataApi(apicon.getApiBaseUrl() + "agentease")
        .then((result) => {
          this.agentesLst = result;
        });
    },        
    fillDatosSeguro: async function () {
      await apicon
        .getDataApi(apicon.getApiBaseUrl() + "guias/" + this.id)
        .then((result) => {
          if (result) {
            this.agente = result.agenteasegurador;
            this.camposBD.seg_id_agente = result.seg_id_agente;
            this.camposBD.seg_no_aplicacion = result.seg_no_aplicacion;
            this.camposBD.seg_valor_contenido = result.seg_valor_contenido;
            this.camposBD.seg_flete_int = result.seg_flete_int;
            this.camposBD.seg_flete_nac = result.seg_flete_nac;
            this.camposBD.seg_valor_total = result.seg_valor_total;
          }
        });
    },    
    asignar: async function (id) {      
      this.overlay = true;
      await apicon
        .updateDataApi(
          apicon.getApiBaseUrl() + "guias/" + this.id,
          this.camposBD
        )
        .then((result) => {
          this.overlay = false;
          this.$swal(result.message);
        });      
    },
    calcularTotal: function(){
        this.camposBD.seg_valor_total = parseFloat(this.camposBD.seg_valor_contenido != null ? this.camposBD.seg_valor_contenido : 0) + parseFloat(this.camposBD.seg_flete_int != null ? this.camposBD.seg_flete_int : 0) + parseFloat(this.camposBD.seg_flete_nac != null ? this.camposBD.seg_flete_nac : 0);
    }
  },
  mounted: async function () {
    apicon.setAuthHeaders();
    await this.fillAgentesLst();    
    await this.fillDatosSeguro();    
  },
};
</script>